import { connect } from 'react-redux';

import UserProfilesPartnershipsAdminScreen from '../components/UserProfilesPartnershipsAdminScreen';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';

const mapStateToProps = (state) => {
  return {
    total: state.userProfilesPartnershipsAdmin.get('total'),
    isLoading: state.userProfilesPartnershipsAdmin.get('isLoading'),
    activeId: storage.get(findStorageType(), 'partnershipId'),
    access_role_admin_in_app: storage.get(findStorageType(), 'partnershipData')
      ?.access_role_admin_in_app,
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    partnershipName: storage.get(findStorageType(), 'partnershipData')?.name,
    role: storage.get(findStorageType(), 'partnershipData')?.role,
  };
};

const UserProfilesPartnershipsAdminScreenContainer = connect(mapStateToProps)(
  UserProfilesPartnershipsAdminScreen
);

export default UserProfilesPartnershipsAdminScreenContainer;
